




















































































import Vue from 'vue';
// import { firebase } from 'mostra';
// import * as firebase from '@/plugins/firebase';
// import brand, { Brand } from '@/modules/exhibitor/brand';
// import booth, { Booth } from '@/modules/exhibitor/booth';
// import { uniq } from 'lodash';
import {
  brand,
  BrandInfoListItem,
} from 'mostra';

// type UniqueUserInfo = {
//   brand: string[];
//   booth: string[];
//   item: string[];
//   exhibition: string[];
// };
//
// export type brandInfo = {
//   id: string;
//   brandName: string;
//   brandUU: number;
//   boothUU: number;
//   itemUU: number;
// };

export type DataType = {
  brandInfoList: BrandInfoListItem[];
  currentPage: number;
  perPage: number;
  isForced: boolean;
  total: number;
};

export default Vue.extend({
  name: 'admin-analysis-brand-index',
  data(): DataType {
    return {
      brandInfoList: [],
      currentPage: 1,
      perPage: 40,
      isForced: false,
      total: 0,
    };
  },
  computed: {
    isFirstPage(): boolean {
      return this.currentPage === 1;
    },
  },
  watch: {
    async isForced(val: boolean) {
      this.$loading(true);
      try {
        this.brandInfoList = await brand.loadBrandInfoList(this.perPage, 1, val);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = 1;
        this.$loading(false);
      }
    },
  },
  async mounted() {
    this.$loading(true);
    try {
      this.brandInfoList = await brand.loadBrandInfoList(this.perPage, 1);
    } catch (error: any) {
      this.$error('ブランドの取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
  methods: {
    async onChangePage(targetPage: number) {
      this.$loading(true);
      try {
        this.brandInfoList = await brand.loadBrandInfoList(this.perPage, targetPage, this.isForced);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = targetPage;
        this.$loading(false);
      }
    },
    async onClickCountAllBrands() {
      this.total = await brand.countAllBrands();
    },
  },
});
